import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getSkuInfoList(skuNo,merchantsName,skuClassifyId,skuName,isShelves,labelValue,activityClassify,specialClassify,pageNum,pageSize) {
  return requestMsg({
    url: '/skuInfo/getSkuInfoList',
    params: {
      skuNo: skuNo,
      merchantsName: merchantsName,
      skuClassifyId: skuClassifyId,
      skuName: skuName,
      isShelves: isShelves,
      labelValue: labelValue,
      activityClassify: activityClassify,
      specialClassify: specialClassify,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}
export function delSkuInfoBySkuId(skuInfoId) {
  return requestMsg({
    url: '/skuInfo/delSkuInfoBySkuId',
    params: {
      skuInfoId: skuInfoId
    }
  })
}

export function getSkuInfoById(skuInfoId) {
  return request({
    url: '/skuInfo/getById',
    params: {
      skuInfoId:skuInfoId
    }
  })
}

export function updateSkuInfo(skuInfo) {
  return requestMsg({
    url: '/skuInfo/updateSkuInfo',
    data: JSON.stringify(skuInfo),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"}
  })
}

export function getSkuInfoClassify() {
  return request({
    url: '/skuClassify/getSkuInfoClassify',
    params: {

    }
  })
}

export function getPmsExtra() {
  return request({
    url: '/pmsExtra/getPmsExtra',
    params: {

    }
  })
}

export function getLabel() {
  return request({
    url: '/pmsLabel/getLabel',
    params: {

    }
  })
}

export function getMerchantNames() {
  return request({
    url: '/merchants/getMerchantNames',
    params: {

    }
  })
}

export function uploadSkuImgs(data) {
  return request({
    method: "POST",
    url: '/skuInfo/uploadImgs',
    data:data,
    headers : {"Content-Type" : "multipart/form-data"}
  })
}

export function addDailyPush(id,dayNum) {
  return requestMsg({
    url: '/dailyPush/addDailyPush',
    params: {
      skuInfoId:id,
      dayNum:dayNum
    }
  })
}

export function addSwiper(id) {
  return requestMsg({
    url: '/swiper/addSwiper',
    params: {
      skuInfoId:id,
    }
  })
}

export function updateTraceability(traceability) {
  return requestMsg({
    url: '/skuInfo/updateTraceability',
    data: JSON.stringify(traceability),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"}
  })
}

export function queryTraceability(id,switchValue) {
  return requestMsg({
    url: '/skuInfo/queryTraceability',
    params: {
      traceabilityId: id,
      switchValue:switchValue
    }
  })
}

export function queryTraceabilityRecord(id,num) {
  return requestMsg({
    url: '/skuInfo/queryTraceabilityRecord',
    params: {
      traceabilityId: id,
      pageNum:num
    }
  })
}

export class SkuClassify {
  constructor(id,classifyName) {
    this.value = id;
    this.label = classifyName
  }
}

export class Extras {
  constructor(id,extraService) {
    this.id = id;
    this.extraService = extraService
  }
}

export class LabelValue {
  constructor(id,labelName) {
    this.id = id;
    this.value = labelName
  }
}

export class SkuLabelValue {
  constructor(LabelValue) {
    this.id = LabelValue.id;
    this.labelName = LabelValue.value
  }
}

export class PmsDetailImg {
  constructor(id,skuId,imgUrl) {
    this.id = id;
    this.skuId = skuId
    this.imgUrl = imgUrl
  }
}
